/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

function Drawer({ navigationData, action, drawer, drawerPosition }) {
  const [itemSize, setSize] = useState("0px");
  const [item, setItem] = useState();
  const location = useLocation();

  const handler = (e, value) => {
    const getItems = document.querySelectorAll(`#${value} li`).length;
    if (value !== item) {
      setSize(`${47 * getItems}px`);
      setItem(value);
    } else {
      setItem("");
      setSize("0px");
    }
  };
  const isActivePath = (currentPath, targetPath) => {
    const cleanCurrent = currentPath.toLowerCase().replace(/\/+$/, "");
    const cleanTarget = targetPath.toLowerCase().replace(/\/+$/, "");
    return (
      cleanCurrent === cleanTarget || cleanCurrent.startsWith(cleanTarget + "/")
    );
  };
  const normalizePath = (path) => {
    if (!path.startsWith("/")) return "/" + path;
    return path;
  };

  console.log(location.pathname);
  return (
    <>
      <div
        onClick={(e) => action(e)}
        className={`binduz-er-news-off_canvars_overlay ${
          drawer ? "binduz-er-news-active" : ""
        }`}
      ></div>
      <div className={`binduz-er-news-offcanvas_menu ${drawerPosition || ""}`}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div
                className={`binduz-er-news-offcanvas_menu_wrapper overflow-style-none ${
                  drawer ? "binduz-er-news-active" : ""
                }`}
              >
                <div
                  onClick={(e) => action(e)}
                  className="binduz-er-news-canvas_close"
                >
                  <a href="#">
                    <i className="fal fa-times"></i>
                  </a>
                </div>
                <div className="binduz-er-news-header-social">
                  <ul className="text-center">
                    <li>
                      <a href="#">facebook</a>
                    </li>
                    <li>
                      <a href="#">Twitter</a>
                    </li>
                    <li>
                      <a href="#">Skype</a>
                    </li>
                  </ul>
                </div>
                <div id="menu" className="text-left ">
                  <ul className="binduz-er-news-offcanvas_main_menu">
                    {navigationData &&
                      navigationData.length > 0 &&
                      navigationData.map((menuItem) => (
                        <li
                          key={menuItem.id}
                          onClick={(e) => handler(e, menuItem.title)}
                          className="binduz-er-news-menu-item-has-children binduz-er-news-active"
                        >
                          <a>{menuItem.title}</a>
                          <ul
                            id={menuItem.title}
                            className="binduz-er-news-sub-menu overflow-hidden"
                            style={{
                              height:
                                item === menuItem.title ? itemSize : "0px",
                            }}
                          >
                            {menuItem.submenu &&
                              menuItem.items.map((submenu) => (
                                <li key={submenu.id}>
                                  <Link
                                    to={normalizePath(submenu.link)}
                                    className={`${
                                      isActivePath(
                                        location.pathname,
                                        submenu.link
                                      )
                                        ? "border-b-2 border-red-500 font-semibold text-red-600"
                                        : ""
                                    }`}
                                  >
                                    {submenu.title}
                                  </Link>
                                </li>
                              ))}
                          </ul>
                        </li>
                      ))}
                  </ul>
                </div>
                <div className="binduz-er-news-offcanvas_footer">
                  <div className="binduz-er-news-logo text-center mb-30 mt-30">
                    <Link to="/" style={{ textDecoration: "none" }}>
                      <p
                        style={{
                          color: "#e31e24",
                          fontWeight: "900",
                          fontSize: "1.6rem",
                          letterSpacing: "0.12em",
                          margin: 0,
                          fontFamily:
                            "'Bebas Neue', 'Impact', 'Arial Black', sans-serif",
                          textTransform: "uppercase",
                        }}
                      >
                        BALOTAZH.COM
                      </p>
                    </Link>
                  </div>
                  <p>
                    I’m Michal Škvarenina, a multi-disciplinary designer
                    currently working at Wild and as a freelance designer.
                  </p>
                  <ul>
                    <li>
                      <i className="fas fa-phone"></i> +212 34 45 45 98
                    </li>
                    <li>
                      <i className="fas fa-home"></i> Angle Bd Abdelmoumen & rue
                      soumaya, Résidence
                    </li>
                    <li>
                      <i className="fas fa-envelope"></i> hello@example.com
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Drawer;
